webpackJsonp([17],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXPAND_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SWITCH_EFFECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TOGGLE_AUTHENTICATED; });
var TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = 'SWITCH_EFFECT';

var TOGGLE_AUTHENTICATED = 'TOGGLE_AUTHENTICATED';

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(10);


/* global  localStorage:true */

/* harmony default export */ __webpack_exports__["a"] = ({
  user: {
    authenticated: false
  },
  login: function login(context, username, password, redirect) {
    context.$http.post('api-token-auth/', JSON.stringify({ 'username': username, 'password': password })).then(function (response) {
      localStorage.setItem('token', response.body.token);
      localStorage.setItem('username', username);
      context.$store.dispatch('toggleAuth', {
        'authenticated': true,
        'username': username,
        'token': response.body.token
      });
      context.$store.dispatch('addToMessageBus', {
        title: 'Success',
        message: 'Welcome back ' + username,
        type: 'success',
        duration: 5000
      });
      // Redirect to a specified route
      if (redirect) {
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push(redirect);
      }
    }, function (error) {
      if (error.status === 400) {
        context.error = error.body.non_field_errors[0];
        return context.error;
      }
      if (error.status === 500) {
        context.error = error.statusText;
        return context.error;
      }
      context.error = 'Server is offline.Please try again in a moment';
    });
  },
  register: function register(context, email, username, password, redirect) {
    context.$http.post('auth/register/', JSON.stringify({ 'email': email, 'username': username, 'password': password })).then(function (response) {
      if (response.status === 201) {
        context.$store.dispatch('addToMessageBus', {
          title: 'Success',
          message: 'You registered successfully.Now login in to start using the system',
          type: 'success',
          duration: 5000
        });
        // Redirect to a specified route
        if (redirect) {
          __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push(redirect);
        }
      } else {
        context.error = 'There was an error.Try to register again';
      }
    }, function (error) {
      if (error.status === 400) {
        if (error.body.username) {
          context.error = error.body.username[0];
          return context.error;
        }
        if (error.body.email) {
          context.error = error.body.email[0];
          return context.error;
        }
      }
      if (error.status === 403) {
        context.error = error.body;
        return context.error;
      }
      if (error.status === 500) {
        context.error = error.statusText;
        return context.error;
      }
      context.error = 'Server is offline.Please try again in a moment';
    });
  },
  logout: function logout(context) {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    context.$store.dispatch('toggleAuth', {
      'authenticated': false,
      'username': '',
      'token': ''
    });
  },
  loggedIn: function loggedIn() {
    return !!localStorage.token;
  },

  // The object to be passed as a header for authenticated requests
  getAuthHeader: function getAuthHeader() {
    return 'JWT ' + localStorage.getItem('token');
  }
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(229),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__ = __webpack_require__(15);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    name: 'Home',
    path: '/',
    component: __webpack_require__(135)
  }].concat(_toConsumableArray(generateRoutesFromMenu(__WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__["a" /* default */].state.items)), [{
    name: 'Register',
    path: '/register',
    component: __webpack_require__(137)
  }, {
    name: 'Log in',
    path: '/login',
    component: __webpack_require__(136)
  }, {
    name: 'My Profile',
    path: '/profile/:username',
    component: __webpack_require__(138)
  }, {
    path: '*',
    redirect: '/'
  }])
}));

// Menu should have 2 levels.
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMAINING_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SOLD_UNITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOUGHT_UNITS; });
/**
 * Created by mugambi on 26/03/17.
 */
var REMAINING_ITEMS = 'accounts/REMAINING_ITEMS';
var SOLD_UNITS = 'accounts/SOLD_UNITS';
var BOUGHT_UNITS = 'accounts/BOUGHT_UNITS';

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_BUSINESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_BUSINESS; });
var FETCH_DETAILS = 'business/FETCH_DETAILS';
var UPDATE_BUSINESS = 'business/UPDATE_BUSINESS';
var CREATE_BUSINESS = 'business/CREATE_BUSINESS';

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SUBTRACT_FROM_CART; });
/**
 * Created by mugambi on 25/03/17.
 */
var ADD_TO_CART = 'cart/ADD_TO_CART';
var REMOVE_FROM_CART = 'cart/REMOVE_FROM_CART';
var SUBTRACT_FROM_CART = 'cart/SUBTRACT_FROM_CART';

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_CATEGORY; });
var FETCH_CATEGORIES = 'categories/FETCH_CATEGORIES';
var CREATE_CATEGORY = 'categories/CREATE_CATEGORY';
var UPDATE_CATEGORY = 'categories/UPDATE_CATEGORY';
var DELETE_CATEGORY = 'categories/DELETE_CATEGORY';

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lazyLoading__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_auth_auth__ = __webpack_require__(5);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// show: meta.label -> name
// name: component name
// meta.label: display label

var state = {
  items: [{
    name: 'Dashboard',
    path: '/dashboard',
    meta: {
      icon: 'fa-tachometer',
      link: 'dashboard/index.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('dashboard', true)
  }, {
    name: 'Categories',
    path: '/categories',
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_2__views_auth_auth__["a" /* default */].loggedIn()) {
        next({
          path: '/login',
          query: { redirect: to.path }
        });
      } else {
        next();
      }
    },

    meta: {
      icon: 'fa-tags'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('categories', true)
  }, {
    name: 'Inventory',
    path: '/inventory',
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_2__views_auth_auth__["a" /* default */].loggedIn()) {
        next({
          path: '/login',
          query: { redirect: to.path }
        });
      } else {
        next();
      }
    },

    meta: {
      icon: 'fa-table'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('inventory', true)
  }, {
    name: 'P.O.S',
    path: '/pos',
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_2__views_auth_auth__["a" /* default */].loggedIn()) {
        next({
          path: '/login',
          query: { redirect: to.path }
        });
      } else {
        next();
      }
    },

    meta: {
      icon: 'fa-shopping-cart'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('pos', true)
  }, {
    name: 'Receipts',
    path: '/receipts',
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_2__views_auth_auth__["a" /* default */].loggedIn()) {
        next({
          path: '/login',
          query: { redirect: to.path }
        });
      } else {
        next();
      }
    },

    meta: {
      icon: 'fa-money'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('receipts', true)
  }, {
    name: 'Bought Item Accounts',
    path: '/accounts/bought',
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_2__views_auth_auth__["a" /* default */].loggedIn()) {
        next({
          path: '/login',
          query: { redirect: to.path }
        });
      } else {
        next();
      }
    },

    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('bought', true),
    meta: {
      icon: 'fa-tasks',
      expanded: false,
      label: 'Bought accounts'
    }
  }, {
    name: 'Sold Item Accounts',
    path: '/accounts/sold',
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_2__views_auth_auth__["a" /* default */].loggedIn()) {
        next({
          path: '/login',
          query: { redirect: to.path }
        });
      } else {
        next();
      }
    },

    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('sold', true),
    meta: {
      icon: 'fa-tasks',
      expanded: false,
      label: 'sold accounts'
    }
  }, {
    name: 'Remaining Item Accounts',
    path: '/accounts/remaining',
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_2__views_auth_auth__["a" /* default */].loggedIn()) {
        next({
          path: '/login',
          query: { redirect: to.path }
        });
      } else {
        next();
      }
    },

    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('remaning', true),
    meta: {
      icon: 'fa-tasks',
      expanded: false,
      label: 'Remaining accounts'
    }
  }, {
    name: 'Manage Business',
    path: '/business',
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_2__views_auth_auth__["a" /* default */].loggedIn()) {
        next({
          path: '/login',
          query: { redirect: to.path }
        });
      } else {
        next();
      }
    },

    meta: {
      icon: 'fa-cogs'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('business', true)
  }]
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* EXPAND_MENU */], function (state, menuItem) {
  if (menuItem.index > -1) {
    if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
      state.items[menuItem.index].meta.expanded = menuItem.expanded;
    }
  } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
    menuItem.item.meta.expanded = menuItem.expanded;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHOW_MESSAGE; });
var SHOW_MESSAGE = 'messages/SHOW_MESSAGE';

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_PRODUCT; });
var FETCH_PRODUCT = 'products/FETCH_PRODUCT';
var FETCH_PRODUCTS = 'products/FETCH_PRODUCTS';
var CREATE_PRODUCT = 'products/CREATE_PRODUCT';
var UPDATE_PRODUCT = 'products/UPDATE_PRODUCT';
var DELETE_PRODUCT = 'products/DELETE_PRODUCT';

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_RECEIPTS; });
/**
 * Created by mugambi on 25/03/17.
 */
var FETCH_RECEIPTS = 'receipts/FETCH_RECEIPTS';

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_DETAILS_USER; });
var FETCH_DETAILS = 'user/FETCH_DETAILS';
var UPDATE_DETAILS_USER = 'user/UPDATE_DETAILS_USER';

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(234),
  /* scopeId */
  "data-v-fcc8eae0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(230),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(220),
  /* scopeId */
  "data-v-0147fcd9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(199)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(225),
  /* scopeId */
  "data-v-5a0007bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */,
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(149);


__WEBPACK_IMPORTED_MODULE_0__app__["a" /* app */].$mount('#app');

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Home.vue": [
		135
	],
	"./accounts/index.vue": [
		243,
		14
	],
	"./auth/login/Login.vue": [
		136
	],
	"./auth/register/Register.vue": [
		137
	],
	"./bought/index.vue": [
		251,
		7
	],
	"./business/index.vue": [
		252,
		4
	],
	"./business/save-form.vue": [
		244,
		13
	],
	"./categories/index.vue": [
		253,
		1
	],
	"./categories/save-category/index.vue": [
		245,
		12
	],
	"./dashboard/index.vue": [
		254,
		8
	],
	"./inventory/index.vue": [
		255,
		3
	],
	"./inventory/save-product/index.vue": [
		246,
		11
	],
	"./pos/index.vue": [
		256,
		2
	],
	"./pos/modals/CardModal.vue": [
		257,
		0
	],
	"./pos/modals/Modal.vue": [
		247,
		15
	],
	"./pos/product-list/index.vue": [
		248,
		9
	],
	"./profile/Profile.vue": [
		138
	],
	"./receipts/index.vue": [
		258,
		10
	],
	"./remaning/index.vue": [
		259,
		5
	],
	"./sold/index.vue": [
		260,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 141;

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_message_Message__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_message_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_helpers_message_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);




/* global  localStorage:true */
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1__components_layout__["a" /* Navbar */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components_layout__["b" /* Sidebar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_1__components_layout__["c" /* AppMain */],
    FooterBar: __WEBPACK_IMPORTED_MODULE_1__components_layout__["d" /* FooterBar */],
    NprogressContainer: __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default.a,
    Messages: __WEBPACK_IMPORTED_MODULE_2__components_helpers_message_Message___default.a
  },
  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 3;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar(!isMobile);
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    sidebar: 'sidebar',
    auth: 'authenticated'
  }),
  created: function created() {
    this.$store.dispatch('addToMessageBus', {
      title: 'Awesome',
      message: 'Welcome to SBA.We are excited',
      type: 'success',
      duration: 5000
    });
    if (!!localStorage.token === true) {
      this.$store.dispatch('toggleAuth', {
        'authenticated': true,
        'username': localStorage.getItem('username'),
        'token': localStorage.getItem('token')
      });
    }
  },

  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(['toggleDevice', 'toggleSidebar'])
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);

var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.messages'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    message: 'getMessages'
  })),
  methods: {
    openNotificationWithType: function openNotificationWithType(type, title, message, duration) {
      openNotification({
        title: title,
        message: message,
        type: type,
        duration: duration
      });
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Levelbar__);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Levelbar: __WEBPACK_IMPORTED_MODULE_0__Levelbar___default.a
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return this.$store.state.pkg;
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      Formerrors: {},
      error: ''
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].logout(this);
    this.$store.dispatch('addToMessageBus', {
      title: 'Oh Snap',
      message: 'You must log in to access the system',
      type: 'danger',
      duration: 5000
    });
  },

  methods: {
    navigate: function navigate() {
      this.$router.push({ path: 'register' });
    },
    submit: function submit() {
      if (this.validate_form()) {
        var redirect = this.$route.query.redirect || 'dashboard';
        __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].login(this, this.credentials.username, this.credentials.password, redirect);
        this.credentials.username = '';
        this.credentials.password = '';
      }
    },
    validate_form: function validate_form() {
      var errors = {};
      if (!this.credentials.username) {
        errors.username = 'Username is required';
      }
      if (!this.credentials.password) {
        errors.password = 'Password is required';
      }
      this.Formerrors = errors;
      return Object.keys(errors).length === 0;
    }
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      credentials: {
        email: '',
        username: '',
        password: ''
      },
      Formerrors: {},
      error: ''
    };
  },

  methods: {
    navigate: function navigate() {
      this.$router.push({ path: 'login' });
    },
    submit: function submit() {
      if (this.validate_form()) {
        __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].register(this, this.credentials.email, this.credentials.username, this.credentials.password, 'login');
        this.credentials.email = '';
        this.credentials.username = '';
        this.credentials.password = '';
      }
    },
    validate_form: function validate_form() {
      var errors = {};
      if (!this.credentials.email) {
        errors.email = 'Email is required';
      }
      if (!this.credentials.username) {
        errors.username = 'Username is required';
      }
      if (!this.credentials.password) {
        errors.password = 'Password is required';
      }
      this.Formerrors = errors;
      return Object.keys(errors).length === 0;
    }
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var token = localStorage.getItem('token');
var initialData = function initialData() {
  return {
    userInForm: {
      email: '',
      first_name: '',
      id: null,
      last_name: '',
      username: ''
    },
    profileInForm: {
      avatar: '',
      national_id: '',
      phone_number: '',
      user: ''
    },
    personal: true,
    profile: false
  };
};
/* global  localStorage:true */
/* harmony default export */ __webpack_exports__["default"] = ({
  data: initialData,
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])({
    user: 'getUserDetails',
    auth: 'authenticated'
  }),
  created: function created() {
    this.$store.dispatch('fetchUserDetails', {
      'token': token
    });
    this.onEditUser(this.user.User);
  },

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])(['updateUser']), {
    onClickpersonal: function onClickpersonal() {
      this.personal = true;
      this.profile = false;
      this.onEditUser(this.user.User);
    },
    onUpdateUser: function onUpdateUser(user) {
      var _this = this;

      var token = localStorage.getItem('token');
      this.updateUser({ 'user': user, 'token': token }).then(function () {
        _this.$store.dispatch('addToMessageBus', {
          title: 'Success',
          type: 'success',
          message: 'Your user details have been updated successfully',
          duration: 5000
        });
      });
    },
    onEditProfile: function onEditProfile(profile) {
      this.profileInForm = _extends({}, profile);
    },
    onEditUser: function onEditUser(user) {
      this.userInForm = _extends({}, user);
    },
    onClickprofile: function onClickprofile() {
      this.personal = false;
      this.profile = true;
      this.onEditProfile(this.user.profile);
    }
  })
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nprogress__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_App_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__app_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_store_mutation_types__ = __webpack_require__(4);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











/* global  localStorage:true */
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_nprogress___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = 'https://sba-api-server.herokuapp.com/api';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  if (request.url !== 'auth/register/') {
    request.headers.set('Authorization', 'JWT ' + localStorage.getItem('token'));
  }
  // continue to next interceptor
  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  next(function (response) {
    if (response.statusText === 'Forbidden') {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('toggleAuth', false);
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push('/login');
    }
  });
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  next(function (response) {
    if (response.body[0] === 'you_have_no_business') {
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push('/business');
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('addToMessageBus', {
        title: 'Oh Snap',
        message: 'You must first create a business',
        type: 'danger',
        duration: 5000
      });
    }
  });
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Content-Type'] = 'application/json';
// Enable devtools
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);

var nprogress = new __WEBPACK_IMPORTED_MODULE_1_vue_nprogress___default.a({ parent: '.nprogress-container' });

var state = __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state;


__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function (route, redirect, next) {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_8_vuex_store_mutation_types__["a" /* TOGGLE_SIDEBAR */], false);
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_7_moment___default()(String(value)).format('dddd, MMMM Do YYYY, h:mm a');
  }
});
var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](_extends({
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  nprogress: nprogress
}, __WEBPACK_IMPORTED_MODULE_4__app_App_vue___default.a));



/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_main_AppMain__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_main_AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__app_main_AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__app_main_AppMain___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_FooterBar__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__footer_FooterBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__footer_FooterBar___default.a; });









/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebar", function() { return toggleSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleDevice", function() { return toggleDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleAuth", function() { return toggleAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandMenu", function() { return expandMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchEffect", function() { return switchEffect; });


var toggleSidebar = function toggleSidebar(_ref, opened) {
  var commit = _ref.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], opened);
};

var toggleDevice = function toggleDevice(_ref2, device) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], device);
};
var toggleAuth = function toggleAuth(_ref3, auth) {
  var commit = _ref3.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* TOGGLE_AUTHENTICATED */], auth);
};

var expandMenu = function expandMenu(_ref4, menuItem) {
  var commit = _ref4.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* EXPAND_MENU */], menuItem);
  }
};

var switchEffect = function switchEffect(_ref5, effectItem) {
  var commit = _ref5.commit;

  if (effectItem) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], effectItem);
  }
};

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pkg", function() { return pkg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "device", function() { return device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authenticated", function() { return authenticated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebar", function() { return sidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effect", function() { return effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuitems", function() { return menuitems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componententry", function() { return componententry; });
var pkg = function pkg(state) {
  return state.pkg;
};
var app = function app(state) {
  return state.app;
};
var device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var authenticated = function authenticated(state) {
  return state.app.auth;
};
var effect = function effect(state) {
  return state.app.effect;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};
var componententry = function componententry(state) {
  return state.menu.items.filter(function (c) {
    return c.meta && c.meta.label === 'Components';
  })[0];
};



/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_app__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_menu__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_messages__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_products__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_categories__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_user__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_business__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_cart__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_receipts__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_accounts__ = __webpack_require__(156);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_5__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_6__modules_menu__["a" /* default */],
    messages: __WEBPACK_IMPORTED_MODULE_7__modules_messages__["a" /* default */],
    products: __WEBPACK_IMPORTED_MODULE_8__modules_products__["a" /* default */],
    categories: __WEBPACK_IMPORTED_MODULE_9__modules_categories__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_10__modules_user__["a" /* default */],
    business: __WEBPACK_IMPORTED_MODULE_11__modules_business__["a" /* default */],
    cart: __WEBPACK_IMPORTED_MODULE_12__modules_cart__["a" /* default */],
    receipts: __WEBPACK_IMPORTED_MODULE_13__modules_receipts__["a" /* default */],
    accounts: __WEBPACK_IMPORTED_MODULE_14__modules_accounts__["a" /* default */]
  },
  state: {
    pkg: __WEBPACK_IMPORTED_MODULE_2_package___default.a
  },
  mutations: {}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["fetchBoughtUnits"] = fetchBoughtUnits;
/* harmony export (immutable) */ __webpack_exports__["fetchSoldtUnits"] = fetchSoldtUnits;
/* harmony export (immutable) */ __webpack_exports__["fetchRemainingUnits"] = fetchRemainingUnits;
/**
 * Created by mugambi on 26/03/17.
 */



function fetchBoughtUnits(_ref) {
  var commit = _ref.commit;

  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('accounts/bought/').then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* BOUGHT_UNITS */], response.body);
  });
}
function fetchSoldtUnits(_ref2) {
  var commit = _ref2.commit;

  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('accounts/sold/').then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SOLD_UNITS */], response.body);
  });
}
function fetchRemainingUnits(_ref3) {
  var commit = _ref3.commit;

  return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('accounts/remaining/').then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* REMAINING_ITEMS */], response.body);
  });
}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRemainigItems", function() { return getRemainigItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBoughtItems", function() { return getBoughtItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSoldItems", function() { return getSoldItems; });
/**
 * Created by mugambi on 26/03/17.
 */
var getRemainigItems = function getRemainigItems(state) {
  return state.accounts.remaining;
};

var getBoughtItems = function getBoughtItems(state) {
  return state.accounts.bought;
};

var getSoldItems = function getSoldItems(state) {
  return state.accounts.sold;
};

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Created by mugambi on 26/03/17.
 */




var initialState = {
  accounts: {
    bought: null,
    remaining: null,
    sold: null
  }
};
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* BOUGHT_UNITS */], function (state, bought) {
  // assign the bought that we got from our fetchBought event to state.bought
  state.accounts.bought = bought;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* REMAINING_ITEMS */], function (state, remaining) {
  // assign the bought that we got from our fetchBought event to state.bought
  state.accounts.remaining = remaining;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SOLD_UNITS */], function (state, sold) {
  // assign the bought that we got from our fetchBought event to state.bought
  state.accounts.sold = sold;
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: _extends({}, initialState),
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: mutations
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(4);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  },
  auth: {
    authenticated: false,
    username: ''
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], function (state, device) {
  state.device.isMobile = device === 'mobile';
  state.device.isTablet = device === 'tablet';
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], function (state, opened) {
  if (state.device.isMobile) {
    state.sidebar.opened = opened;
  } else {
    state.sidebar.opened = true;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], function (state, effectItem) {
  for (var name in effectItem) {
    state.effect[name] = effectItem[name];
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* TOGGLE_AUTHENTICATED */], function (state, auth) {
  state.auth.authenticated = auth.authenticated;
  state.auth.username = auth.username;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(12);
/* harmony export (immutable) */ __webpack_exports__["fetchBusiness"] = fetchBusiness;
/* harmony export (immutable) */ __webpack_exports__["createBusiness"] = createBusiness;
/* harmony export (immutable) */ __webpack_exports__["updateBusiness"] = updateBusiness;
/* harmony export (immutable) */ __webpack_exports__["saveBusiness"] = saveBusiness;


function fetchBusiness(_ref) {
  var commit = _ref.commit;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('businesses/').then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* FETCH_DETAILS */], response.body);
  }, function (error) {
    console.log(error.body.detail);
  });
}
function createBusiness(_ref2, _ref3) {
  var commit = _ref2.commit;
  var business = _ref3.business;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('businesses/', business).then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* CREATE_BUSINESS */], response.body);
  });
}
function updateBusiness(_ref4, _ref5) {
  var commit = _ref4.commit;
  var business = _ref5.business;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put('businesses/' + business.id + '/', business).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* UPDATE_BUSINESS */], response.body);
  });
}
function saveBusiness(_ref6, _ref7) {
  var commit = _ref6.commit,
      state = _ref6.state;
  var business = _ref7.business;

  var index = state.business.findIndex(function (b) {
    return b.id === business.id;
  });
  if (index !== -1) {
    return updateBusiness({ commit: commit }, { business: business });
  } else {
    return createBusiness({ commit: commit }, { business: business });
  }
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBusiness", function() { return getBusiness; });
var getBusiness = function getBusiness(state) {
  return state.business;
};

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(12);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var initialState = {
  business: []
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* FETCH_DETAILS */], function (state, business) {
  state.business = business;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* CREATE_BUSINESS */], function (state, business) {
  state.business.push(business);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* UPDATE_BUSINESS */], function (state, business) {
  var index = state.business.findIndex(function (p) {
    return p.id === business.id;
  });

  if (index !== -1) {
    // We need to replace the array entirely so that vue can recognize
    // the change and re-render entirely.
    // See http://vuejs.org/guide/list.html#Caveats
    state.business.splice(index, 1, business);
  }
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: _extends({}, initialState),
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: mutations
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["addToCart"] = addToCart;
/* harmony export (immutable) */ __webpack_exports__["removeFromCart"] = removeFromCart;
/* harmony export (immutable) */ __webpack_exports__["subtractFromCart"] = subtractFromCart;
/**
 * Created by mugambi on 25/03/17.
 */



function addToCart(_ref, product) {
  var commit = _ref.commit,
      state = _ref.state;

  var record = state.cart.find(function (p) {
    return p.id === product.id;
  });

  if (!record || record.quantity < 10) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* ADD_TO_CART */], product);
  }
}

function removeFromCart(_ref2, productId) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* REMOVE_FROM_CART */], productId);
}

function subtractFromCart(_ref3, productId) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SUBTRACT_FROM_CART */], productId);
}

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCartItems", function() { return getCartItems; });
/**
 * Created by mugambi on 25/03/17.
 */

var getCartItems = function getCartItems(state) {
  return state.cart;
};

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Created by mugambi on 25/03/17.
 */





var initialState = {
  cart: []
};

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* ADD_TO_CART */], function (state, product) {
  var record = state.cart.find(function (p) {
    return p.id === product.id;
  });
  if (!record) {
    state.cart.push({
      id: product.id,
      name: product.product_name,
      code: product.product_code,
      price: product.unit_price,
      quantity: 1
    });
  } else {
    record.quantity++;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* REMOVE_FROM_CART */], function (state, productId) {
  state.cart = state.cart.filter(function (p) {
    return p.id !== productId;
  });
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SUBTRACT_FROM_CART */], function (state, productId) {
  var record = state.cart.find(function (p) {
    return p.id === productId;
  });
  if (record && record.quantity === 1) {
    state.cart = state.cart.filter(function (p) {
      return p.id !== productId;
    });
  } else if (record) {
    record.quantity--;
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: _extends({}, initialState),
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__,
  mutations: mutations
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(14);
/* harmony export (immutable) */ __webpack_exports__["fetchCategories"] = fetchCategories;
/* harmony export (immutable) */ __webpack_exports__["createCategory"] = createCategory;
/* harmony export (immutable) */ __webpack_exports__["updateCategory"] = updateCategory;
/* harmony export (immutable) */ __webpack_exports__["deleteCategory"] = deleteCategory;
/* harmony export (immutable) */ __webpack_exports__["saveCategory"] = saveCategory;



function fetchCategories(_ref) {
  var commit = _ref.commit;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('categories/').then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* FETCH_CATEGORIES */], response.body);
  });
}
function createCategory(_ref2, _ref3) {
  var commit = _ref2.commit,
      state = _ref2.state;
  var category = _ref3.category;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('categories/', category).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* CREATE_CATEGORY */], response.body);
  }, function (error, state) {
    console.log(error.body.business);
  });
}
function updateCategory(_ref4, _ref5) {
  var commit = _ref4.commit,
      state = _ref4.state;
  var category = _ref5.category;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put('categories/' + category.id + '/', category).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* UPDATE_CATEGORY */], response.body);
  }, function (error) {
    if (error.status === 403) {
      return state.messages.push({
        title: 'Oh Snap!',
        message: 'Sorry you need to log in again',
        type: 'danger',
        duration: 5000

      });
    }
    if (error.status === 500) {
      return state.messages.push({
        title: 'Oh Snap!',
        message: 'There seems to be an error please try again',
        type: 'danger',
        duration: 5000

      });
    }
    return state.messages.push({
      title: 'Oh Snap!',
      message: 'Server is offline.Please try again in a moment',
      type: 'danger',
      duration: 5000
    });
  });
}
function deleteCategory(_ref6, _ref7) {
  var commit = _ref6.commit;
  var id = _ref7.id,
      token = _ref7.token;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete('categories/' + id + '/').then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* DELETE_CATEGORY */], id);
  });
}

function saveCategory(_ref8, _ref9) {
  var commit = _ref8.commit,
      state = _ref8.state;
  var category = _ref9.category;

  var index = state.categories.findIndex(function (c) {
    return c.id === category.id;
  });
  if (index !== -1) {
    return updateCategory({ commit: commit }, { category: category });
  } else {
    return createCategory({ commit: commit }, { category: category });
  }
}

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCategories", function() { return getCategories; });
var getCategories = function getCategories(state) {
  return state.categories;
};

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(14);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var initialState = {
  categories: []
};
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* FETCH_CATEGORIES */], function (state, categories) {
  // assign the categories that we got from our FETCH_CATEGORIES event to state.all
  state.categories = categories;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* CREATE_CATEGORY */], function (state, category) {
  state.categories.push(category);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* UPDATE_CATEGORY */], function (state, category) {
  var index = state.categories.findIndex(function (p) {
    return p.id === category.id;
  });

  if (index !== -1) {
    // We need to replace the array entirely so that vue can recognize
    // the change and re-render entirely.
    // See http://vuejs.org/guide/list.html#Caveats
    state.categories.splice(index, 1, category);
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* DELETE_CATEGORY */], function (state, categoryid) {
  state.categories = state.categories.filter(function (p) {
    return p.id !== categoryid;
  });
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: _extends({}, initialState),
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: mutations
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(141)("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(16);
/* harmony export (immutable) */ __webpack_exports__["addToMessageBus"] = addToMessageBus;


function addToMessageBus(_ref, message) {
  var commit = _ref.commit,
      state = _ref.state;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* SHOW_MESSAGE */], message);
}

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMessages", function() { return getMessages; });
var getMessages = function getMessages(state) {
  return state.messages[state.messages.length - 1];
};

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var initialstate = {
  messages: []
};
var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SHOW_MESSAGE */], function (state, message) {
  state.messages.push({
    title: message.title,
    message: message.message,
    type: message.type,
    duration: message.duration
  });
});
/* harmony default export */ __webpack_exports__["a"] = ({
  state: _extends({}, initialstate),
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__,
  mutations: mutations
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(17);
/* harmony export (immutable) */ __webpack_exports__["fetchProducts"] = fetchProducts;
/* harmony export (immutable) */ __webpack_exports__["fetchProduct"] = fetchProduct;
/* harmony export (immutable) */ __webpack_exports__["createProduct"] = createProduct;
/* harmony export (immutable) */ __webpack_exports__["updateProduct"] = updateProduct;
/* harmony export (immutable) */ __webpack_exports__["deleteProduct"] = deleteProduct;
/* harmony export (immutable) */ __webpack_exports__["saveProduct"] = saveProduct;



function fetchProducts(_ref, token) {
  var commit = _ref.commit;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('simple-products/', { Authorization: 'JWT ' + token }).then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* FETCH_PRODUCTS */], response.body);
  });
}
function fetchProduct(_ref2, _ref3) {
  var commit = _ref2.commit;
  var productId = _ref3.productId,
      token = _ref3.token;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('products/' + productId, { Authorization: 'JWT ' + token }).then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* FETCH_PRODUCT */], response.body);
  });
}
function createProduct(_ref4, _ref5) {
  var commit = _ref4.commit;
  var product = _ref5.product,
      token = _ref5.token;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('products/', product, { Authorization: 'JWT ' + token }).then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* CREATE_PRODUCT */], response.body);
  });
}
function updateProduct(_ref6, _ref7) {
  var commit = _ref6.commit;
  var product = _ref7.product,
      token = _ref7.token;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put('products/' + product.id, product, { Authorization: 'JWT ' + token }).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* UPDATE_PRODUCT */], response.body);
  });
}
function deleteProduct(_ref8, _ref9) {
  var commit = _ref8.commit;
  var id = _ref9.id,
      token = _ref9.token;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.delete('products/' + id + '/', { Authorization: 'JWT ' + token }).then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* DELETE_PRODUCT */], id);
  });
}
function saveProduct(_ref10, _ref11) {
  var commit = _ref10.commit,
      state = _ref10.state;
  var product = _ref11.product,
      token = _ref11.token;

  var index = state.products.findIndex(function (p) {
    return p.id === product.id;
  });
  if (index !== -1) {
    return updateProduct({ commit: commit }, { product: product, token: token });
  } else {
    return createProduct({ commit: commit }, { product: product, token: token });
  }
}

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProducts", function() { return getProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMainProducts", function() { return getMainProducts; });
var getProducts = function getProducts(state) {
  return state.products;
};
var getMainProducts = function getMainProducts(state) {
  return state.main_products;
};

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var initialState = {
  products: [],
  main_products: []
};
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* FETCH_PRODUCT */], function (state, product) {
  var index = state.main_products.findIndex(function (p) {
    return p.id === product.id;
  });

  if (index === -1) {
    state.main_products.push(product);
  } else {
    state.main_products.splice(index, 1, product);
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* FETCH_PRODUCTS */], function (state, products) {
  // assign the products that we got from our FETCH_PRODUCTS event to state.products
  state.products = products;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* CREATE_PRODUCT */], function (state, product) {
  state.main_products.push(product);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* UPDATE_PRODUCT */], function (state, product) {
  var index = state.main_products.findIndex(function (p) {
    return p.id === product.id;
  });

  if (index !== -1) {
    // We need to replace the array entirely so that vue can recognize
    // the change and re-render entirely.
    // See http://vuejs.org/guide/list.html#Caveats
    state.main_products.splice(index, 1, product);
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* DELETE_PRODUCT */], function (state, id) {
  state.products = state.products.filter(function (p) {
    return p.id !== id;
  });
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: _extends({}, initialState),
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: mutations
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(18);
/* harmony export (immutable) */ __webpack_exports__["fetchReceipts"] = fetchReceipts;
/**
 * Created by mugambi on 25/03/17.
 */


function fetchReceipts(_ref) {
  var commit = _ref.commit;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('receipts/').then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* FETCH_RECEIPTS */], response.body);
  });
}

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReceipts", function() { return getReceipts; });
/**
 * Created by mugambi on 25/03/17.
 */

var getReceipts = function getReceipts(state) {
  return state.receipts;
};

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Created by mugambi on 25/03/17.
 */




var initialState = {
  receipts: []
};
var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* FETCH_RECEIPTS */], function (state, receipts) {
  // assign the receipts that we got from our FETCH_receipts event to state.receipts
  state.receipts = receipts;
});
/* harmony default export */ __webpack_exports__["a"] = ({
  state: _extends({}, initialState),
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: mutations
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(19);
/* harmony export (immutable) */ __webpack_exports__["fetchUserDetails"] = fetchUserDetails;
/* harmony export (immutable) */ __webpack_exports__["updateUser"] = updateUser;



function fetchUserDetails(_ref, token) {
  var commit = _ref.commit;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('user-details/', { Authorization: 'JWT ' + token, showProgressBar: false }).then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* FETCH_DETAILS */], response.body);
  });
}
function updateUser(_ref2, _ref3) {
  var commit = _ref2.commit;
  var user = _ref3.user,
      token = _ref3.token;

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put('users/' + user.id + '/', user, { Authorization: 'JWT ' + token }).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* UPDATE_DETAILS_USER */], response.body);
  });
}

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserDetails", function() { return getUserDetails; });
var getUserDetails = function getUserDetails(state) {
  return state.user;
};

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(19);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var initialState = {
  user: []
};
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* FETCH_DETAILS */], function (state, user) {
  state.user = user;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* UPDATE_DETAILS_USER */], function (state, user) {
  state.user.User = user;
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: _extends({}, initialState),
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: mutations
});

/***/ }),
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default.a
  },

  data: function data() {
    return {
      list: null
    };
  },
  created: function created() {
    this.getList();
  },


  computed: {
    name: function name() {
      return this.$route.name;
    }
  },

  methods: {
    getList: function getList() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched);
      }
      this.list = matched;
    }
  },

  watch: {
    $route: function $route() {
      this.getList();
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tooltip: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__["a" /* default */]
  },
  props: {
    show: Boolean
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    pkginfo: 'pkg',
    sidebar: 'sidebar',
    auth: 'authenticated'
  }),

  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['toggleSidebar'])
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default.a
  },

  props: {
    show: Boolean
  },

  data: function data() {
    return {
      isReady: false
    };
  },
  mounted: function mounted() {
    var route = this.$route;
    if (route.name) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    menu: 'menuitems'
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['expandMenu']), {
    isExpanded: function isExpanded(item) {
      return item.meta.expanded;
    },
    toggle: function toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      });
    },
    shouldExpandMatchItem: function shouldExpandMatchItem(route) {
      var matched = route.matched;
      var lastMatched = matched[matched.length - 1];
      var parent = lastMatched.parent || lastMatched;
      var isParent = parent === lastMatched;

      if (isParent) {
        var p = this.findParentFromMenu(route);
        if (p) {
          parent = p;
        }
      }

      if ('expanded' in parent.meta && !isParent) {
        this.expandMenu({
          item: parent,
          expanded: true
        });
      }
    },
    generatePath: function generatePath(item, subItem) {
      return '' + (item.component ? item.path + '/' : '') + subItem.path;
    },
    findParentFromMenu: function findParentFromMenu(route) {
      var menu = this.menu;
      for (var i = 0, l = menu.length; i < l; i++) {
        var item = menu[i];
        var k = item.children && item.children.length;
        if (k) {
          for (var j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item;
            }
          }
        }
      }
    }
  }),

  watch: {
    $route: function $route(route) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  }

});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return this.$store.state.pkg;
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },

  mounted: function mounted() {
    if (this.separator) {
      this.$el.style.setProperty('--separator', '"' + this.separator + '"');
    }
  },


  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    type: String,
    title: String,
    message: String,
    direction: {
      type: String,
      default: 'Right'
    },
    duration: {
      type: Number,
      default: 4500
    },
    container: {
      type: String,
      default: '.notifications'
    }
  },

  data: function data() {
    return {
      $_parent_: null,
      show: true
    };
  },
  created: function created() {
    var $parent = this.$parent;
    if (!$parent) {
      var parent = document.querySelector(this.container);
      if (!parent) {
        // Lazy creating `div.notifications` container.
        var className = this.container.replace('.', '');
        var Notifications = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
          name: 'Notifications',
          render: function render(h) {
            return h('div', {
              'class': _defineProperty({}, '' + className, true)
            });
          }
        });
        $parent = new Notifications().$mount();
        document.body.appendChild($parent.$el);
      } else {
        $parent = parent.__vue__;
      }
      // Hacked.
      this.$_parent_ = $parent;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$_parent_) {
      this.$_parent_.$el.appendChild(this.$el);
      this.$parent = this.$_parent_;
      delete this.$_parent_;
    }
    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        return _this.close();
      }, this.duration);
    }
  },
  destroyed: function destroyed() {
    this.$el.remove();
  },


  computed: {
    transition: function transition() {
      return 'bounce-' + this.direction;
    },
    enterClass: function enterClass() {
      return 'bounceIn' + this.direction;
    },
    leaveClass: function leaveClass() {
      return 'bounceOut' + this.direction;
    }
  },

  methods: {
    closedByUser: function closedByUser() {
      this.$emit('closed-by-user');
      clearTimeout(this.timer);
      this.show = false;
    },
    close: function close() {
      this.$emit('closed-automatically');
      clearTimeout(this.timer);
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy();
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nprogress-container'
});

/***/ }),
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */,
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 20,
	"./af.js": 20,
	"./ar": 27,
	"./ar-dz": 21,
	"./ar-dz.js": 21,
	"./ar-kw": 22,
	"./ar-kw.js": 22,
	"./ar-ly": 23,
	"./ar-ly.js": 23,
	"./ar-ma": 24,
	"./ar-ma.js": 24,
	"./ar-sa": 25,
	"./ar-sa.js": 25,
	"./ar-tn": 26,
	"./ar-tn.js": 26,
	"./ar.js": 27,
	"./az": 28,
	"./az.js": 28,
	"./be": 29,
	"./be.js": 29,
	"./bg": 30,
	"./bg.js": 30,
	"./bn": 31,
	"./bn.js": 31,
	"./bo": 32,
	"./bo.js": 32,
	"./br": 33,
	"./br.js": 33,
	"./bs": 34,
	"./bs.js": 34,
	"./ca": 35,
	"./ca.js": 35,
	"./cs": 36,
	"./cs.js": 36,
	"./cv": 37,
	"./cv.js": 37,
	"./cy": 38,
	"./cy.js": 38,
	"./da": 39,
	"./da.js": 39,
	"./de": 42,
	"./de-at": 40,
	"./de-at.js": 40,
	"./de-ch": 41,
	"./de-ch.js": 41,
	"./de.js": 42,
	"./dv": 43,
	"./dv.js": 43,
	"./el": 44,
	"./el.js": 44,
	"./en-au": 45,
	"./en-au.js": 45,
	"./en-ca": 46,
	"./en-ca.js": 46,
	"./en-gb": 47,
	"./en-gb.js": 47,
	"./en-ie": 48,
	"./en-ie.js": 48,
	"./en-nz": 49,
	"./en-nz.js": 49,
	"./eo": 50,
	"./eo.js": 50,
	"./es": 52,
	"./es-do": 51,
	"./es-do.js": 51,
	"./es.js": 52,
	"./et": 53,
	"./et.js": 53,
	"./eu": 54,
	"./eu.js": 54,
	"./fa": 55,
	"./fa.js": 55,
	"./fi": 56,
	"./fi.js": 56,
	"./fo": 57,
	"./fo.js": 57,
	"./fr": 60,
	"./fr-ca": 58,
	"./fr-ca.js": 58,
	"./fr-ch": 59,
	"./fr-ch.js": 59,
	"./fr.js": 60,
	"./fy": 61,
	"./fy.js": 61,
	"./gd": 62,
	"./gd.js": 62,
	"./gl": 63,
	"./gl.js": 63,
	"./gom-latn": 64,
	"./gom-latn.js": 64,
	"./he": 65,
	"./he.js": 65,
	"./hi": 66,
	"./hi.js": 66,
	"./hr": 67,
	"./hr.js": 67,
	"./hu": 68,
	"./hu.js": 68,
	"./hy-am": 69,
	"./hy-am.js": 69,
	"./id": 70,
	"./id.js": 70,
	"./is": 71,
	"./is.js": 71,
	"./it": 72,
	"./it.js": 72,
	"./ja": 73,
	"./ja.js": 73,
	"./jv": 74,
	"./jv.js": 74,
	"./ka": 75,
	"./ka.js": 75,
	"./kk": 76,
	"./kk.js": 76,
	"./km": 77,
	"./km.js": 77,
	"./kn": 78,
	"./kn.js": 78,
	"./ko": 79,
	"./ko.js": 79,
	"./ky": 80,
	"./ky.js": 80,
	"./lb": 81,
	"./lb.js": 81,
	"./lo": 82,
	"./lo.js": 82,
	"./lt": 83,
	"./lt.js": 83,
	"./lv": 84,
	"./lv.js": 84,
	"./me": 85,
	"./me.js": 85,
	"./mi": 86,
	"./mi.js": 86,
	"./mk": 87,
	"./mk.js": 87,
	"./ml": 88,
	"./ml.js": 88,
	"./mr": 89,
	"./mr.js": 89,
	"./ms": 91,
	"./ms-my": 90,
	"./ms-my.js": 90,
	"./ms.js": 91,
	"./my": 92,
	"./my.js": 92,
	"./nb": 93,
	"./nb.js": 93,
	"./ne": 94,
	"./ne.js": 94,
	"./nl": 96,
	"./nl-be": 95,
	"./nl-be.js": 95,
	"./nl.js": 96,
	"./nn": 97,
	"./nn.js": 97,
	"./pa-in": 98,
	"./pa-in.js": 98,
	"./pl": 99,
	"./pl.js": 99,
	"./pt": 101,
	"./pt-br": 100,
	"./pt-br.js": 100,
	"./pt.js": 101,
	"./ro": 102,
	"./ro.js": 102,
	"./ru": 103,
	"./ru.js": 103,
	"./sd": 104,
	"./sd.js": 104,
	"./se": 105,
	"./se.js": 105,
	"./si": 106,
	"./si.js": 106,
	"./sk": 107,
	"./sk.js": 107,
	"./sl": 108,
	"./sl.js": 108,
	"./sq": 109,
	"./sq.js": 109,
	"./sr": 111,
	"./sr-cyrl": 110,
	"./sr-cyrl.js": 110,
	"./sr.js": 111,
	"./ss": 112,
	"./ss.js": 112,
	"./sv": 113,
	"./sv.js": 113,
	"./sw": 114,
	"./sw.js": 114,
	"./ta": 115,
	"./ta.js": 115,
	"./te": 116,
	"./te.js": 116,
	"./tet": 117,
	"./tet.js": 117,
	"./th": 118,
	"./th.js": 118,
	"./tl-ph": 119,
	"./tl-ph.js": 119,
	"./tlh": 120,
	"./tlh.js": 120,
	"./tr": 121,
	"./tr.js": 121,
	"./tzl": 122,
	"./tzl.js": 122,
	"./tzm": 124,
	"./tzm-latn": 123,
	"./tzm-latn.js": 123,
	"./tzm.js": 124,
	"./uk": 125,
	"./uk.js": 125,
	"./ur": 126,
	"./ur.js": 126,
	"./uz": 128,
	"./uz-latn": 127,
	"./uz-latn.js": 127,
	"./uz.js": 128,
	"./vi": 129,
	"./vi.js": 129,
	"./x-pseudo": 130,
	"./x-pseudo.js": 130,
	"./yo": 131,
	"./yo.js": 131,
	"./zh-cn": 132,
	"./zh-cn.js": 132,
	"./zh-hk": 133,
	"./zh-hk.js": 133,
	"./zh-tw": 134,
	"./zh-tw.js": 134
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;

/***/ }),
/* 209 */,
/* 210 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(226),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(228),
  /* scopeId */
  "data-v-71a4d2ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(232),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(221),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(227),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(231),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(223),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(222),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(224),
  /* scopeId */
  "data-v-4b0dce0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(233),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "is-ancestor tile"
  }, [_c('div', {
    staticClass: "tile is-parent column is-half is-offset-one-quarter"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Register ")]), _vm._v(" "), _c('div', {
    staticClass: "block styles-box"
  }, [(_vm.error) ? _c('notification', {
    attrs: {
      "title": 'Oh Snap',
      "container": '.styles-box',
      "type": 'danger',
      "direction": 'Down',
      "message": _vm.error,
      "duration": 0
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.Formerrors.username
    },
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.username = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.Formerrors.username) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.Formerrors.username))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.email),
      expression: "credentials.email"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.Formerrors.email
    },
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.credentials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.Formerrors.email) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.Formerrors.email))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "help is-success"
  }, [_vm._v("Your email will be kept a secret")])]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.Formerrors.password
    },
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.Formerrors.password) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.Formerrors.password))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n                Register\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        _vm.navigate()
      }
    }
  }, [_vm._v("\n                Login\n              ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        _vm.toggleSidebar(!_vm.sidebar.opened)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('router-link', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9),
      "alt": _vm.pkginfo.description
    }
  }), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": 'v' + _vm.pkginfo.version,
      "placement": "right",
      "type": "success",
      "size": "small",
      "no-animate": true,
      "always": true,
      "rounded": true
    }
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "vue"
  }, [_vm._v("Small Business Analytics ")]), _c('strong', {
    staticClass: "admin"
  }, [_vm._v("SBA")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [(_vm.auth.authenticated) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'My Profile',
        params: {
          username: _vm.auth.username
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v("\n          My Profile\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [(_vm.auth.authenticated) ? _c('router-link', {
    staticClass: "nav-item last-item",
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  })]), _vm._v("Log out")]) : _vm._e(), _vm._v(" "), (!_vm.auth.authenticated) ? _c('router-link', {
    staticClass: "nav-item last-item",
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  })]), _vm._v("Log in")]) : _vm._e()], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Code licensed under "), _c('a', {
    attrs: {
      "href": 'https://github.com/' + _vm.repository + '/blob/master/LICENSE'
    }
  }, [_vm._v(_vm._s(_vm.license))]), _vm._v(".")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-code"
  })]), _vm._v(" with "), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": "https://github.com/indevsDigital"
    }
  }, [_vm._v("Indevs Digital")]), _vm._v(".")])
}]}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block column is-half is-offset-one-quarter"
  }, [_c('button', {
    staticClass: "button is-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onClickpersonal()
      }
    }
  }, [_vm._v("Personal Details")]), _vm._v(" "), _c('button', {
    staticClass: "button is-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onClickprofile()
      }
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.personal && _vm.userInForm) ? _c('div', {
    staticClass: "column animated"
  }, [_c('div', {
    staticClass: "is-ancestor tile"
  }, [_c('div', {
    staticClass: "tile is-parent column is-half is-offset-one-quarter"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Update Personal Details ")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.username),
      expression: "userInForm.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.userInForm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.email),
      expression: "userInForm.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.userInForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.first_name),
      expression: "userInForm.first_name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.userInForm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.last_name),
      expression: "userInForm.last_name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.userInForm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.last_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.onUpdateUser(_vm.userInForm)
      }
    }
  }, [_vm._v("\n                Update\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.profile && _vm.user.profile) ? _c('div', {
    staticClass: "column animated"
  }, [_c('div', {
    staticClass: "is-ancestor tile"
  }, [_c('div', {
    staticClass: "tile is-parent column is-half is-offset-one-quarter"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Update Profile ")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-square"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.profile.avatar,
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(_vm.userInForm.username))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("Profile Picture")])])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.username),
      expression: "userInForm.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.userInForm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Nation I.D")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.first_name),
      expression: "userInForm.first_name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "I.D"
    },
    domProps: {
      "value": (_vm.userInForm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.last_name),
      expression: "userInForm.last_name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.userInForm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.last_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success"
  }, [_vm._v("\n                Update\n              ")])])])])])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden && _vm.auth.authenticated
    }
  }), _vm._v(" "), _c('messages'), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show, slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n    General\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', [(item.path) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem) {
      return (subItem.path) ? _c('li', [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem)
        }
      }, [_vm._v("\n              " + _vm._s(subItem.meta && subItem.meta.label || subItem.name) + "\n            ")])], 1) : _vm._e()
    }))]) : _vm._e()], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.message) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.openNotificationWithType(_vm.message.type, _vm.message.title, _vm.message.message, _vm.message.duration)) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: ['notification', 'animated', _vm.type ? ("is-" + _vm.type) : '']
  }, [_c('button', {
    staticClass: "delete touchable",
    on: {
      "click": function($event) {
        _vm.closedByUser()
      }
    }
  }), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "is-ancestor tile"
  }, [_c('div', {
    staticClass: "tile is-parent column is-half is-offset-one-quarter"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Login ")]), _vm._v(" "), _c('div', {
    staticClass: "block styles-box"
  }, [(_vm.error) ? _c('notification', {
    attrs: {
      "title": 'Oh Snap',
      "container": '.styles-box',
      "type": 'danger',
      "direction": 'Down',
      "message": _vm.error,
      "duration": 0
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.Formerrors.username
    },
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.username = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.Formerrors.username) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.Formerrors.username))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.Formerrors.password
    },
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.Formerrors.password) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.Formerrors.password))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n                Login\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        _vm.navigate()
      }
    }
  }, [_vm._v("\n                Register\n              ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('levelbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "200",
      "src": __webpack_require__(9),
      "alt": _vm.description
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v(_vm._s(_vm.name.replace('-', ' ')))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _c('p', [_vm._v("Help small business manage their businesses and also learn from data generated by business")])])
},staticRenderFns: []}

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports) {

module.exports = {
	"name": "SBA",
	"version": "0.1.12",
	"description": "Simple Business Analytics",
	"repository": "indevsDigital/sba-client",
	"homepage": "https://sba-web.firebaseapp.com/",
	"license": "MIT",
	"author": {
		"name": "Humphrey Mugambi",
		"email": "mugagambi@gmail.com",
		"url": "www.hmugambi.me"
	},
	"keywords": [
		"admin",
		"bulma",
		"dashboard",
		"data",
		"visualization",
		"vue"
	],
	"engines": {
		"node": ">=4",
		"npm": ">=3"
	},
	"scripts": {
		"build": "cross-env NODE_ENV=production node build/build.js",
		"clean": "rm -rf dist",
		"dev": "cross-env NODE_ENV=development node build/dev-server.js",
		"electron": "cross-env NODE_ELECTRON=true npm run build && electron electronIndex.js",
		"gh": "npm run build && gh-pages -d dist",
		"lint": "eslint --ext .js .vue client/*",
		"lint:fix": "eslint --fix --ext .js .vue electron.js client/* build/* config/*",
		"test": "echo lol"
	},
	"dependencies": {
		"animate.css": "3.5.2",
		"animejs": "^2.0.1",
		"axios": "^0.15.3",
		"bulma": "^0.3.2",
		"font-awesome": "4.7.0",
		"mdi": "^1.8.36",
		"moment": "^2.18.1",
		"plotly.js": "^1.24.2",
		"vue": "^2.2.2",
		"vue-bulma-brace": "^0.1.0",
		"vue-bulma-breadcrumb": "^1.0.1",
		"vue-bulma-card": "^1.0.2",
		"vue-bulma-chartist": "^1.1.0",
		"vue-bulma-chartjs": "^1.0.4",
		"vue-bulma-collapse": "1.0.3",
		"vue-bulma-datepicker": "^1.3.0",
		"vue-bulma-expanding": "^0.0.1",
		"vue-bulma-jump": "^0.0.2",
		"vue-bulma-message": "^1.1.1",
		"vue-bulma-modal": "1.0.1",
		"vue-bulma-notification": "^1.1.1",
		"vue-bulma-progress-bar": "^1.0.2",
		"vue-bulma-progress-tracker": "0.0.4",
		"vue-bulma-quill": "0.0.1",
		"vue-bulma-rating": "^1.0.1",
		"vue-bulma-slider": "^1.0.2",
		"vue-bulma-switch": "^1.0.4",
		"vue-bulma-tabs": "^1.1.2",
		"vue-bulma-tooltip": "^1.0.3",
		"vue-cleave": "1.1.1",
		"vue-lory": "0.0.4",
		"vue-nprogress": "0.1.5",
		"vue-peity": "0.5.0",
		"vue-resource": "^1.2.1",
		"vue-router": "^2.3.0",
		"vuex": "^2.2.1",
		"vuex-router-sync": "^4.1.2",
		"wysiwyg.css": "0.0.2"
	},
	"devDependencies": {
		"autoprefixer": "^6.7.7",
		"babel-core": "^6.21.0",
		"babel-eslint": "^7.1.1",
		"babel-loader": "^6.4.0",
		"babel-plugin-transform-export-extensions": "^6.8.0",
		"babel-preset-es2015": "^6.14.0",
		"babel-preset-stage-2": "^6.17.0",
		"connect-history-api-fallback": "^1.3.0",
		"cross-env": "^3.1.3",
		"css-loader": "^0.27.1",
		"electron-devtools-installer": "^2.0.1",
		"eslint": "^3.17.1",
		"eslint-config-standard": "^7.0.1",
		"eslint-friendly-formatter": "^2.0.7",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^2.0.1",
		"eslint-plugin-promise": "^3.5.0",
		"eslint-plugin-standard": "^2.1.1",
		"eventsource-polyfill": "^0.9.6",
		"express": "^4.15.2",
		"extract-text-webpack-plugin": "^2.0.0-beta.4",
		"file-loader": "^0.10.1",
		"html-webpack-plugin": "^2.25.0",
		"http-proxy-middleware": "^0.17.4",
		"imports-loader": "^0.7.0",
		"node-sass": "^4.1.1",
		"opn": "^4.0.2",
		"ora": "^1.1.0",
		"postcss-loader": "^1.3.3",
		"progress-bar-webpack-plugin": "^1.9.1",
		"sass-loader": "^6.0.3",
		"serve-favicon": "^2.4.1",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^3.0.1",
		"url-loader": "^0.5.7",
		"vue-html-loader": "^1.2.3",
		"vue-loader": "^11.1.4",
		"vue-template-compiler": "^2.2.2",
		"webpack": "^2.2.1",
		"webpack-dev-middleware": "^1.9.0",
		"webpack-hot-middleware": "^2.14.0",
		"webpack-merge": "^4.0.0"
	}
};

/***/ }),
/* 240 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(140);


/***/ })
],[241]);


// WEBPACK FOOTER //
// assets/js/app.d7285a35bf3750f7280b.js